





































import { Component, Vue } from 'vue-property-decorator';
import { Route } from 'node_modules/vue-router/types';
import { focus } from '@/directives';
import { IEpic, IProject } from '@/lib/interfaces';
import { getProject, createEpic } from '@/services/api.service';
import Project from './Project.vue';

@Component({
  directives: {
    focus,
  },
})
export default class Epics extends Vue {
  private project: IProject | null = (this.$parent as Project).project;
  private newEpic: IEpic = {
    title: '',
    _creator_id: '',
    code: 0,
  };
  private createEpic = false;

  public async doneEpic() {
    const epic: IEpic = await createEpic(this.newEpic, this.project!._id!);
    this.project!.epics!.unshift(epic);
    this.cancelEpic();
  }

  public cancelEpic() {
    this.newEpic.title = '';
    this.createEpic = false;
  }
}
